import SortButton from "@/components/SortButton";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { Column, Header } from "@tanstack/react-table";

interface SortButtonProps {
  header: Header<ReadShiftReportDepartmentEntry, unknown>;
  children: React.ReactNode;
}

const ShiftReportColumnHeader = ({ header, children }: SortButtonProps) => {
  if (!header.column.getCanSort()) {
    return children;
  }

  const sort = header.column.getIsSorted();

  const handleSortChange = (
    column: Column<ReadShiftReportDepartmentEntry, unknown>,
    direction: "asc" | "desc" | false,
  ) => {
    if (direction === false) {
      column.clearSorting();
    } else {
      column.toggleSorting(direction === "desc");
    }
  };

  return (
    <div className="flex gap-2 items-center">
      <div className="truncate">{children}</div>
      <SortButton
        header={header}
        sortValue={sort}
        forceSortedStyle={false}
        onSortChange={handleSortChange}
        className="shrink-0"
      />
    </div>
  );
};

export default ShiftReportColumnHeader;
